<ion-content>
  <ion-grid>
    <ion-row class="header-row">
      <ion-col>
        <div class="Filters">
          <ion-label>{{'ACTION_MANAGEMENT.ACTION_FILTERS' | translate}}</ion-label>
        </div>
        <div class="close-div">
          <ion-icon (click)="dismiss()" name="close-outline" class="close-icon"></ion-icon>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="action_status_row">
      <ion-col>
        <ion-label>{{'ACTION_MANAGEMENT.AACTION_STATUS' | translate}}</ion-label>
      </ion-col>
    </ion-row>
    <ion-row>

      <ion-col size="6">
        <ion-item lines="none" class="status_item">
          <ion-checkbox type="checkbox" class="checkbox-margin-right" checked={{actiondata.action_status_open}}
            name="open" value="open" (ionChange)="action_Check($event)">
          </ion-checkbox>
          <ion-label>{{'ACTION_MANAGEMENT.ACTION_OPEN' | translate}}</ion-label>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-item lines="none" class="status_item" style="margin-left: -80px;">
          <ion-checkbox type="checkbox" class="checkbox-margin-right" checked={{actiondata.action_status_close}}
            name="closed" value="closed" (ionChange)="action_Check($event)">
          </ion-checkbox>
          <ion-label>{{'ACTION_MANAGEMENT.ACTION_CLOSED' | translate}}</ion-label>
        </ion-item>
      </ion-col>
    </ion-row>

    <div class="border"></div>
    <ion-row>
      <ion-radio-group mode="md" (ionChange)="changevalue($event)" value={{selectedvalue}}>
        <ion-list-header>
          <ion-label class="time_period">{{'ACTION_MANAGEMENT.TIME_PERIOD' | translate}}</ion-label>
        </ion-list-header>
        <ion-item lines="none">
          <ion-label>{{'QR_MANAGEMENT.ALL' | translate}}</ion-label>
          <ion-radio slot="start" class="radio_btn_color" value="all"></ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>{{'DASHBOARD.GRAPH.TODAYS' | translate}}</ion-label>
          <ion-radio slot="start" class="radio_btn_color" value="1"></ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>{{'ACTION_MANAGEMENT.ACTION_LAST' | translate}} 7 {{'ACTION_MANAGEMENT.ACTION_DAYS' | translate}}
          </ion-label>
          <ion-radio slot="start" class="radio_btn_color" value="7"></ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>{{'ACTION_MANAGEMENT.ACTION_LAST' | translate}} 15 {{'ACTION_MANAGEMENT.ACTION_DAYS' | translate}}
          </ion-label>
          <ion-radio slot="start" class="radio_btn_color" value="15"></ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>{{'ACTION_MANAGEMENT.ACTION_LAST' | translate}} 30 {{'ACTION_MANAGEMENT.ACTION_DAYS' | translate}}
          </ion-label>
          <ion-radio slot="start" class="radio_btn_color" value="30"></ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>{{'ACTION_MANAGEMENT.ACTION_LAST' | translate}} 60 {{'ACTION_MANAGEMENT.ACTION_DAYS' | translate}}
          </ion-label>
          <ion-radio slot="start" class="radio_btn_color" value="60"></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-row>
  </ion-grid>

  <div class="ok_div">
    <ion-chip type="button" [disabled]="!disabled_actionsubmit" class="saveBtnCss" (click)="actionsubmit()">
      {{'APP_OK'
      |
      translate}}</ion-chip>
  </div>
</ion-content>